import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-schedule-view-delete',
    template: require('./scheduleViewDialogDelete.html')
})
export class ScheduleViewDeleteDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<ScheduleViewDeleteDialog>) public dialogRef: MatDialogRef<ScheduleViewDeleteDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value);
    }

}
